export default "__VITE_ASSET__YRNVeA4d__"